import React from 'react';
import { Box, Typography, Container, Grid, Card, CardContent, Avatar } from '@mui/material';
import PeopleIcon from '@mui/icons-material/People';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import { keyframes } from '@mui/system';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';

const bounceAnimation = keyframes`
  0%, 20%, 50%, 80%, 100% { transform: translateY(0); }
  40% { transform: translateY(-15px); }
  60% { transform: translateY(-7px); }
`;

const AboutUs = () => {
    const theme = useTheme();
    const { t } = useTranslation();

    const cardBackgroundColor = theme.palette.mode === 'light' ? '#ffb74d' : '#2d3b4f';
    const avatarBackgroundColor = theme.palette.mode === 'light' ? '#ff6f61' : '#ffb74d';
    
    return (
        <Box sx={{ backgroundColor: theme.palette.background.primary, color: theme.palette.text.default, py: 8 }}>
            <Container maxWidth="lg">
                <Typography variant="h2" align="center" gutterBottom sx={{ color: theme.palette.mode, fontWeight: 'bold', mb: 4 }}>
                    {t('aboutUs.title')}
                </Typography>
                <Typography variant="h5" align="center" sx={{ mb: 6 }}>
                    {t('aboutUs.subtitle')}
                </Typography>
                
                <Grid container spacing={4}>
                    {[{
                        icon: <PeopleIcon />,
                        title: t('aboutUs.teamTitle'),
                        description: t('aboutUs.teamDescription'),
                    }, {
                        icon: <RocketLaunchIcon />,
                        title: t('aboutUs.missionTitle'),
                        description: t('aboutUs.missionDescription'),
                    }, {
                        icon: <EmojiEventsIcon />,
                        title: t('aboutUs.visionTitle'),
                        description: t('aboutUs.visionDescription'),
                    }].map((item, index) => (
                        <Grid item xs={12} sm={4} key={index}>
                            <Card sx={{ backgroundColor: cardBackgroundColor, color: 'white', textAlign: 'center', animation: `${bounceAnimation} 2s infinite` }}>
                                <CardContent>
                                    <Avatar sx={{ bgcolor: avatarBackgroundColor, width: 56, height: 56, mx: 'auto', mb: 2 }}>
                                        {item.icon}
                                    </Avatar>
                                    <Typography variant="h6" fontWeight="bold">{item.title}</Typography>
                                    <Typography>{item.description}</Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </Container>
        </Box>
    );
};

export default AboutUs;
